import { maskItem } from '@/components/DashboardCard/utils/maskItem';
import React from 'react';

import { CellTypeProps } from '../../interfaces';
import { Container } from './styles';

const Progress: React.FC<CellTypeProps> = ({
  extraValue,
  children,
  color,
  percentage,
  backgroundColor,
  primaryBackgroundColor,
  textAlign,
  fontWeight,
  maskValue,
  value,
}) => {
  return (
    <Container
      backgroundColor={backgroundColor}
      primaryBackgroundColor={primaryBackgroundColor ?? 'inherit'}
      percentage={percentage ?? 0}
      color={color}
      textAlign={textAlign}
      fontWeight={fontWeight}
    >
      {maskValue ? maskItem(maskValue, value) : value}
      {children !== '-' && extraValue}
    </Container>
  );
};

export default Progress;
